export const SURVEYS_ENDPOINTS = {
  LOOKUPS: "/surveys/lookups",
  STANDARD: "/surveys/standard",
  STANDARD_DETAIL: (id) => `/surveys/standard/${id}`,
  STANDARD_PUBLISH: (id) => `/surveys/standard/${id}/publish`,
  STANDARD_ARCHIVE: (id) => `/surveys/standard/${id}/archive`,
  CUSTOM: "/surveys/custom",
  CUSTOM_DETAIL: (id) => `/surveys/custom/${id}`,
  CUSTOM_PUBLISH: (id) => `/surveys/custom/${id}/publish`,
  CUSTOM_ARCHIVE: (id) => `/surveys/custom/${id}/archive`,
  SHARE: (type, id) => `/surveys/${type}/${id}/share`,
  INVITE: (type, id) => `/surveys/${type}/${id}/invite`,
  INVITE_RESOLVE: (type, id) => `/surveys/${type}/${id}/invite/resolve`,
  INVITE_SUGGESTIONS: (type, id, query) =>
    `/surveys/${type}/${id}/invite/suggestions${
      query ? `?q=${encodeURIComponent(query)}` : ""
    }`,
  SHARED: (type, id) => `/surveys/shared/${type}/${id}`,
  AVAILABLE: "/surveys/available",
  RESPONSES: "/surveys/responses",
  RESPONSE_DETAIL: (responseId) => `/surveys/responses/${responseId}`,
  RESPONSE_DELETE: (responseId) => `/surveys/responses/${responseId}`,
  RESPONSE: "/surveys/response",
  QUESTION_BANK: "/question-bank",
  QUESTION_BANK_DETAIL: (id) => `/question-bank/${id}`,
  QUESTION_BANK_IMPORT_STANDARD: "/question-bank/import/standard",
  QUESTION_BANK_DERIVE: "/question-bank/derive",
  QUESTION_BANK_ARCHIVE: (id) => `/question-bank/${id}/archive`,
};
